<template>
  <div :class="`header`">
    <div :class="`left-slot`">
      <i v-if="headerConfig.back || $route.meta.isBack" class="el-icon-back" @click="$router.go(-1)"></i>
    </div>
    <span v-if="!metaTitle">{{ $store.state.project.name }}</span>
    <span v-else class="title">{{
        $route.meta.replacedType &&
        $route.params.type ?
        tr[$route.params.type] : metaTitle
      }}</span>


    <div class="right-slot">
      <component v-if="headerConfig.rightComponent" :is="headerConfig.rightComponent"/></div>
  </div>
</template>

<script>
import AddJob from './AddJob';
import ChangeLocation from "./ChangeLocation";

export default {
  name: 'Header',

  components: {ChangeLocation, AddJob},

  data() {
    return {
      routers: {
        jobs: {
          back: true,
          rightComponent: 'AddJob',
        },
        objects: {
          back: true,
        },
        jobCreate: {
          back: true,
        },
      },

      tr: {
        line: 'Список линий',
        welder: 'Сварщики',
        welder_cons: 'Сварочные материалы',
        team: 'Бригадиры',
      },
    };
  },

  computed: {
    metaTitle() {
      if(this.$route.meta.isProgress) {
        return this.$route.meta.title + ' ' +  ((this.$store.getters.permission.unit_name) || 'стоимость')
      }
      return this.$route.meta.title
    },
    headerConfig() {
      return this.routers[this.$route.name] || {};
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  height: 50px;
  //padding-top: 30px; // IOS ONLY
  left: 0;
  top: 0;
  right: 0;
  z-index: 7;
  background-color: #3676CB;
  color: #fff;
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .el-icon-back {
    color: #ffffff;
    font-size: 28px;
    cursor: pointer;
  }

  .left-slot {
    width: 64px;
    margin-left: 64px;
  }

  .right-slot {
    width: 42px;
    margin-right: 32px;
    display: flex;
    justify-content: flex-end;
  }
}

.title {
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 10px;
}

.globe {
  cursor: pointer;
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue